module.exports = __webpack_public_path__ + "static/media/rules_yellow-01.d1800c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/rules_yellow-01.png
// module id = 515
// module chunks = 0